/**
 *Created by jmmartinez on 20/03/19
 * v 1.1  01/04/2019 Eliminacion de breaks tras returns en switch (campo.tipo)
 * v 1.2  30/04/2019 Sustitución cadenas por enumerados de tipos
 *                   Añadido el tipo ImagenUrlUploader
 * v 1.3  09/05/2019 Añadida prop valorTextoInicial para pasarselo a los SelectorListaClase
 * v 1.4  14/05/2019 Añadido ColorPicker y TimePickerf
 * v 1.5  06/06/2019 Modificado getRenderSelectorLista para que no de error al recibir un valor null por borrar Elemento.
 * v 1.6  22/07/2019 Añadido campo Entero
 *                   Modificado para ForeignJPA
 *                   Nuevo SelectorListaClaseObjeto
 * v 1.7  30/09/2019 Modificado para usar el nombre del paquete dinámicamente en la deteccion de clases.
 *                   Transimision del campo.ordenInicial a SelectorListaClase
 * v.1.8  03/10/2019 Modificado el componente que se usa en las Foreign a SelectorListaObjetoCache
 * v.1.85 04/10/2019 Añadido al campo la propiedad cache, para indicar si se debe usar la caché o no.
 * v.1.9  17/10/2019 Modificado getRenderFromCampo en el caso de FK: para variar el componente SelectorLista según sea JPA o EJ2
 *                   Modificado en getRenderSelectorListaObjeto <SelectorListaClaseObjeto, para que el evento onElementoChanged devuelva el objeto y no el campo codigo.
 * v.1.10 23/10/2019 Añadida propiedad TabOrderManager
 *                   Añadido inputRef al crear InputGroup en la función getRenderInput
 *                   Añdido onKeyPressed para detectar el return.
 * v.1.11 24/10/2019 Añadido labelInfo= * en los label de los campos obligatorios
 * v.1.12 31/10/2019 Añadidas propiedades tabOrderManager y campoNombre en la llamada al componente getRenderSelectorListaClaseObjeto
 *                   Añadidas propiedades de focus a CheckBox.
 * v.1.13  05/11/2019 Añadida comprobación de existencia de tabOrderMAnager en método keyPress
 * v.1.14  08/11/2019 Añadido soporte para tipo CELLTIPO_IMAGENLISTA
 * v.1.15  27/01/2020 Añadido soporte para el tipo CELLTIPO_OPCIONES
 * v.1.16  25/02/2020 En getRenderDateTime quitamos la asignacion del dia actual cuando es null.
 * v.1.17  29/02/2020 Añadido título al generar SelectorPeriodo
 * v.1.18  10/02/2020 Añadida en getRenderInput, la llamada a onBlur definida en elementoConfig del campo.
 * v.1.19  12/02/2020 Modificado getRenderInput para asignar onBlur sólo si existe el props.
 * v.1.20  17/03/2020 Añadidos tipos CAMPOTIPO_FLOTANTE y CAMPOTIPO_MONEDA
 *                    Creada funcion getIcon.
 * v.1.21  18/03/2020 Modificada funcion blur para comprobar numericos
 * v.1.22  01/04/2020 Añadido CAMPOTIPO_FECHAACTIVABLE
 * v.1.23  28/04/2020 En el método getRenderDateTimeActivable, pasamos de parámetro fecha el valor o cero si no existe.
 * v.1.24  28/05/2020 Añadido campoIdMostrar en las funciones para mostrar SelectorListaClaseObjeto y SelectorListaClaseObjetoCache
 * v.1.25  30/05/2020 Añadido CAMPOTIPO_PORCENTAJE y getRenderInputNumericPorcentaje
 * v.1.26  29/06/2020 Añadido CAMPOTIPO_COMBOOBJETO y getRenderComboObjeto
 * v.1.27  10/09/2020 Modificado el método getRenderInput,  aplicado en onChange sobre la cadena la función toUpperCase()
 * v.1.28  19/09/2020 Añadido CAMPOTIPO_MEMO
 * v.1.29  21/09/2020 Añadido CAMPOTIPO_LABEL
 * v.2.0   30/09/2020 Cambiado a framework2
 * v.2.1   13/10/2020 Modificado el método getRenderInput, en onChange comporbamos campo.nomayus para hacer toUpperCase().
 * v.2.2   20/10/2020 Añadido getRenderListaChecks
 * v.2.3   06/11/2020 Modificado getRenderImagenURLUploader para pasar en el campo la url del servicio de download y upload.
 * v.2.4   08/11/2020 Añadida ocultacion de título en getRenderSelectorListaObjeto mediante campo.mostrarTitulo
 *                    En el render de <ImagenUploader añadido titulo=campo.titulo y anchoImagen= campo.anchoImagen
 * v.2.5   12/11/2020 en el render de ListaClaseObjeto: SelectorListaClaseObjeto  pasamos la porpiedad mostrarCodigoid.
 * v.2.6   22/02/2021 en getRenderMemo aplicamos campo.height en el estulo del <TextArea>
 * v.2.6   04/03/2021 Añadido componente CAMPOTIPO_COMBOIMPRESORAS
 * v.2.7   06/07/2021 Añadida propieda en campos readOnly y su uso en changeCampo
 * v.2.8   13/07/2021 Añadido en ComboBoxEnum, la propiedad modo35.
 * v.2.9   21/09/2021 Corregido getRenderDateTimeActivable el paso de conHora a campo.conHora.
 * v.2.10  28/03/2022 Modificado getRenderInput añadiendo readOnly={campo.readOnly ? campo.readOnly : false }
 * v.2.11  30/03/2022 Añadido componente CAMPOTIPO_SELECTORDOCUMENTOS
 * v.2.12  27/04/2022 Modificado el metodo getRenderCheck modificada la configuración añadiendo el Boolean():  <Check checked={Boolean(valor)}
 * v.2.13  28/04/2022 Añadida la gestión de CAMPOTIPO_CADENAACCION con el método getRenderInputAccion.
 *
 * v.2.14  05/06/2022  Unión Sidemur y Planifikator
 * v.2.15  20/05/2022  Añadida gestión de tipo CAMPOTIPO_FECHACADENA
 * v.2.16  08/06/2022  Modificada función getRenderInputNumeric
 * v.2.17  16/06/2022  Modificado getRenderListaObjeto para pasar los parámetros onAccion y accionIcon
 * v.2.18  01/07/2022  Gestion del nuevo tipo CAMPOTIPO_OPCIONES_CLAVENONUMERICA
 * v.2.19  21/07/2022  En getRenderInput, pintamos el texto de campo.sufijo.
 * v.2.20  02/02/2023  En función getRenderSelectorListaObjeto añadida propiedad readonly
 * v.2.21  02/05/2023  En funcion getRenderInputAccion, añadido icon2 y onAccion2.
 * v.2.22  12/07/2023  En getRenderDateTimeCadena añadido el parámetro readOnly en la llamada a <FechaCadenaInput
 * v.2.23  05/09/2023  Modificado el import para usar el ComboBox de /ej2/UI
 * v.2.24  30/01/2024  Modificado getRenderComboObjeto para pasar el parámetro pausaLoad

 * v.2.25  08/01/2025  En el método getRenderComboEnum automatizamos el parametro modo35 según el valor de pasarela
                       En getRenderSectorLista, creamos el objeto elementoSeleccionado para pasarlo como elementoSeleccionadoInicial a <SectorListaClase
                       Añadida la prop componentsManager, que se usa en algunos renders de componentes.
                       En getRenderDateTimeCadena, en la llamada a <FechaCadenaInput añadido  ref={componentsManager.getRef(campo.campo)}

 * **/


import React from 'react'
import {
    CAMPOTIPO_CADENA, CAMPOTIPO_FECHA, CAMPOTIPO_FECHAHORA, CAMPOTIPO_FECHAACTIVABLE,
    CAMPOTIPO_FECHACADENA, CAMPOTIPO_FECHAHORACADENA,
    CAMPOTIPO_CHECK, CAMPOTIPO_BOOLEANO, CAMPOTIPO_COMBO, CAMPOTIPO_COMBOENUM, CAMPOTIPO_COMBOOBJETOS,
    CAMPOTIPO_RADIO, CAMPOTIPO_IMAGENURL, CAMPOTIPO_IMAGENURLUPLOADER, CAMPOTIPO_FECHAPERIODO,
    CAMPOTIPO_COLOR, CAMPOTIPO_HORA, CAMPOTIPO_ENTERO, CAMPOTIPO_OPCIONES, CAMPOTIPO_FLOTANTE,
    CAMPOTIPO_MONEDA, CAMPOTIPO_PORCENTAJE, CAMPOTIPO_MEMO, CAMPOTIPO_LABEL,
    CAMPOTIPO_LISTACHECKS,
    CAMPOTIPO_ICONOACCION, CAMPOTIPO_BOTONACCION,
    CAMPOTIPO_COMBOIMPRESORAS, CAMPOTIPO_SELECTORDOCUMENTOS, CAMPOTIPO_CADENAACCION,
    CAMPOTIPO_OPCIONES_CLAVENONUMERICA,
    CAMPOTIPO_HTMLMEMO, CAMPOTIPO_FIRMAMAIL,
} from "./TiposCampos"
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import {FormGroup, InputGroup, Checkbox, Icon, Radio, RadioGroup, NumericInput, TextArea, Button} from "@blueprintjs/core";
import {
    servicioRestful,
    servicioFicheros,
    servidor,
    servidorImagenes,
    nombrePaquete, tipoPasarela,
    servidorDocumentos, servicioDocumental
} from "../../../dental/Configuracion"
import ComboBox from "./ComboBox";
import ComboBoxEnum from "../UI/ComboBoxEnum";
import SelectorListaClase from "./SelectorListaClase"
import SelectorListaClaseObjeto from "./SelectorListaClaseObjeto"
import DateTimeInput from "../../blueprint/DateTimeInput";
import SelectorPeriodo from "./SelectorPeriodo";
import ColorPicker from "../../color/ColorPicker";
import TimeInput from "../../blueprint/TimeInput"
import {getTimestampFromNow} from "../utils/DateUtils"
import FileUploader from "./FileUploader"
import ImagenUploader from "./ImagenUploader"
import {CELLTIPO_IMAGENLISTA} from "./TiposCeldas"
import SelectorOpciones from "./SelectorOpciones";
import DateTimeActivable from "./DateTimeActivable";
import ComboBoxClase from "./ComboBoxClase"
import ListaChecks from "./ListaChecks";
import {StringDeNumeroToArrayDeNumeros, ArrayDeNumerosToStringDeNumeros} from "../utils/ArrayUtils"
import ComboBoxImpresoras from "./ComboBoxImpresoras";
import SelectorDocumentos from "./SelectorDocumentos";
import FechaCadenaInput from "./FechaCadenaInput";
import HTMLEditorQuill from "./HTMLEditorQuill";
import FirmaMail from "./FirmaMail";

class ComponenteEntrada extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            campo: {},
        }
    }

    componentDidMount() {
        const {campo} = this.props;
        this.setState({campo: campo});
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.campo !== prevState.campo) {
            newState.campo = nextProps.campo;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    getRenderFromCampo = (campo, valor, valorTextoInicial, index) => {


        /*console.log("-- getRenderFromCampo ---", campo.campo);
        console.log("valor");
        console.log(valor);
        console.log("valorTextoInicial");
        console.log(valorTextoInicial);
        */

        if (campo && campo.tipo && campo.tipo.includes(".")) {
            //console.log("*****   Tipo Foreign")
            if (campo.tipo.includes(nombrePaquete)) {
                if (tipoPasarela && tipoPasarela === "JPA")
                    return this.getRenderSelectorListaObjeto(campo, valor, valorTextoInicial, index);
                else
                    return this.getRenderSelectorLista(campo, valor, valorTextoInicial, index);
            }
        } else {
            //console.log("*****  No Tipo Foreign: ", campo.tipo)
            switch (campo.tipo) {
                case CAMPOTIPO_CADENA:
                    return this.getRenderInput(campo, valor, index);
                case CAMPOTIPO_CADENAACCION:
                    return this.getRenderInputAccion(campo, valor, index);
                case CAMPOTIPO_FECHA:
                    return this.getRenderDateTime(campo, valor, false, index);
                case CAMPOTIPO_FECHAHORA:
                    return this.getRenderDateTime(campo, valor, true, index);
                case CAMPOTIPO_FECHAACTIVABLE:
                    return this.getRenderDateTimeActivable(campo, valor, false, index);
                case CAMPOTIPO_FECHACADENA:
                    return this.getRenderDateTimeCadena(campo, valor, false, index);
                case CAMPOTIPO_FECHAHORACADENA:
                    return this.getRenderDateTimeCadena(campo, valor, true, index);
                case CAMPOTIPO_CHECK:
                case CAMPOTIPO_BOOLEANO:
                    return this.getRenderCheck(campo, valor, index);
                case CAMPOTIPO_COMBO:
                    return this.getRenderCombo(campo, valor, index);
                case CAMPOTIPO_COMBOENUM:
                    return this.getRenderComboEnum(campo, valor, index);
                case CAMPOTIPO_COMBOOBJETOS:
                    return this.getRenderComboObjeto(campo, valor, index);
                case CAMPOTIPO_RADIO:
                    return this.getRenderRadio(campo, valor, index);
                case CAMPOTIPO_IMAGENURL:
                    return this.getRenderImagenURL(campo, valor, index);
                case CAMPOTIPO_IMAGENURLUPLOADER:
                    return this.getRenderImagenURLUploader(campo, valor, index);
                case CAMPOTIPO_FECHAPERIODO:
                    return this.getRenderSelectorPeriodo(campo, valor, index);
                case CAMPOTIPO_COLOR:
                    return this.getRenderColorPicker(campo, valor, index);
                case CAMPOTIPO_HORA:
                    return this.getRenderTimePicker(campo, valor, index);
                case CAMPOTIPO_ENTERO:
                    return this.getRenderInputNumeric(campo, valor, index);
                case CAMPOTIPO_OPCIONES:
                    return this.getRenderComboOpciones(campo, valor, index);
                case CAMPOTIPO_OPCIONES_CLAVENONUMERICA:
                    return this.getRenderComboOpciones(campo, valor, index);
                case CAMPOTIPO_FLOTANTE:
                case CAMPOTIPO_MONEDA:
                    return this.getRenderInput(campo, valor, index);
                case CAMPOTIPO_PORCENTAJE:
                    return this.getRenderInputNumericPorcentaje(campo, valor, index);
                case CAMPOTIPO_MEMO:
                    return this.getRenderMemo(campo, valor, index);
                case CAMPOTIPO_LABEL:
                    return this.getRenderLabel(campo, valor, index);
                case CAMPOTIPO_LISTACHECKS:
                    return this.getRenderListaChecks(campo, valor, index);
                /*
                case CAMPOTIPO_ICONOACCION:
                    return this.getRenderIconoAccion(campo, valor, index);
                case CAMPOTIPO_BOTONACCION:
                    return this.getRenderBotonAccion(campo, valor, index);
                */
                case CAMPOTIPO_COMBOIMPRESORAS:
                    return this.getRenderComboImpresoras(campo, valor, index);
                case CAMPOTIPO_SELECTORDOCUMENTOS:
                    return this.getRenderSelectorDocumentos(campo, valor, index);
                case CAMPOTIPO_HTMLMEMO:
                    return this.getRenderHTMLMemo(campo, valor, index);
                case CAMPOTIPO_FIRMAMAIL:
                    return this.getRenderFirmaMail(campo, valor, index);

                default:
                    return this.getRenderInput(campo, valor, index);

            }
        }
    }



    keyPress= (target, campoNombre) =>{
        const {tabOrderManager} = this.props;
        if(tabOrderManager && target.charCode===13){
            tabOrderManager.setFocusSiguiente(campoNombre);
        }
    }

    blur= (campo) => {
        const {valor} = this.state;
        const {onBlur} = this.props;
        if (campo.tipo === CAMPOTIPO_MONEDA || campo.tipo === CAMPOTIPO_FLOTANTE){
            //comprobamos que es un decimal
            //console.log("Blur: " + valor);
            if (isNaN(valor)) {
                console.log("isNAN");
                this.changeCampo (campo, "0");
            }
            else{
                onBlur && onBlur(campo);
            }
        }
        else {
            onBlur && onBlur(campo);
        }
    }

    getIcon= (campo) => {
        switch (campo.tipo) {
            case CAMPOTIPO_CADENA:  return "draw"; break;
            case CAMPOTIPO_ENTERO:  return "numerical"; break;
            case CAMPOTIPO_FLOTANTE:return "function"; break;
            case CAMPOTIPO_MONEDA:  return "euro"; break;
            default:                return "draw"; break;
        }
    }


    getRenderInput= (campo, valor, index) => {
        const {tabOrderManager, onBlur} = this.props;
        //console.log("* getRenderInput", campo);
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={campo.obligatorio ? "*" : ""}>
                <InputGroup
                    id= {campo.campo}
                    leftIcon= { campo.icon ? campo.icon : this.getIcon(campo)}
                    placeholder= {campo.titulo}
                    value={valor ? valor : ""}
                    onChange={ (event) => this.changeCampo(campo,
                        campo.noMayus ? event.target.value : event.target.value.toUpperCase())  }
                    inputRef={ campo.campo && tabOrderManager ? tabOrderManager.getRef(campo.campo) : null }
                    onKeyPress={(target) => {this.keyPress(target, campo.campo)}}
                    //onBlur={onBlur ? () => onBlur(campo) : null}
                    onBlur={() => this.blur(campo)}
                    readOnly={campo.readOnly ? campo.readOnly : false }
                />
                <spam style={{fontSize: 10}}>{campo.sufijo}</spam>
            </FormGroup>
        );
    }

    /*
    getRenderInputNumeric= (campo, valor, index) => {
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <NumericInput
                    id= {campo.campo}
                    leftIcon={campo.icon}
                    placeholder= {campo.titulo}
                    value={ valor ?  valor : 0 }
                    onValueChange={(valueAsNumber, valueAsString) => this.changeCampo(campo, valueAsString)  }

                />
            </FormGroup>
        );
    }
    */


    getRenderInputNumeric= (campo, valor, index) => {
        const {tabOrderManager} = this.props;
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <InputGroup
                    id= {campo.campo}
                    leftIcon= { campo.icon ? campo.icon : this.getIcon(campo)}
                    placeholder= {campo.titulo}
                    value={valor ? valor : ""}
                    //onChange={ (event) => this.changeCampo(campo, isNaN(valor) ? "0" : valor)  }
                    onChange={ (event) => this.changeCampo(campo, isNaN(event.target.value) ? "0" : event.target.value )  }
                    inputRef={ campo.campo && tabOrderManager ? tabOrderManager.getRef(campo.campo) : null }
                    onKeyPress={(target) => {this.keyPress(target, campo.campo)}}
                    onBlur={() => this.blur(campo)}
                    readOnly={campo.readOnly ? campo.readOnly : false }
                />
            </FormGroup>
        );
    }


    getRenderInputNumericPorcentaje= (campo, valor, index) => {
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <NumericInput
                    id= {campo.campo}
                    leftIcon="percentage" //{campo.icon}
                    placeholder= {campo.titulo}
                    value={ valor ?  valor : 0 }
                    onValueChange={(valueAsNumber, valueAsString) => this.changeCampo(campo, valueAsString)  }
                    min={0}
                    max={100}
                />
            </FormGroup>
        );
    }

    getRenderCheck= (campo, valor, index) => {
        const {tabOrderManager} = this.props;
        //console.log("!!!! getRenderCheck");
        //console.log("campo: ", campo.campo);
        //console.log("valor: ", valor);
        return (
            <FormGroup style={{width: '100%'}} key={index} >
                <Checkbox
                    style={{paddingTop: 30}}
                    checked={Boolean(valor)}
                    onChange={ (event) =>  this.changeCampo(campo, event.target.checked)}>
                        <Icon icon={campo.icon}/>
                        {campo.titulo}
                </Checkbox>
            </FormGroup>

        );
    }

    getRenderCombo= (campo, valor, index) => {
        //console.log("valor: ", valor);
        return (
            <FormGroup style={{width: '100%'}} key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <ComboBox
                    id= {campo.campo}
                    fieldText="texto"
                    fieldKey="valor"
                    items={campo.valores}
                    onValueChanged={(objeto) => this.changeCampo(campo, objeto.valor)}
                    placeholder= {campo.titulo}
                    filterable={false}
                    popoverClassName="popover"
                />
            </FormGroup>
        )
    }

    getRenderComboEnum= (campo, valor, index) => {
        const {urlServicioRestful} = this.props;
        let modo35= false;
        if (tipoPasarela && tipoPasarela === "EJ2")
            modo35= true;
        return (
            <FormGroup style={{width: '100%'}} key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <ComboBoxEnum
                    id= {campo.campo}
                    urlServicioRestful={urlServicioRestful}
                    onValueChanged={(objeto) => this.changeCampo(campo, objeto.nombre)}
                    placeholder= {campo.titulo}
                    enumValue={valor}
                    enumClase= {campo.enumClase}
                    //modo35={campo.modo35}
                    modo35={modo35}
                />
            </FormGroup>
        )
    }


    //campo.tipo dice que es COMBOOBJETO y campo.clase la clase a descargar
    getRenderComboObjeto= (campo, valor, index) => {
        const {urlServicioRestful, tabOrderManager, labelInLine} = this.props;
        const campoClave= "codigo";
        const campoMostrar= "nombre";
        const campoIdMostrar= "codigoid";

        //console.log("XXXXXXXXXXX getRenderCOmboObjeto: XXXXXXXXXXXXXXXXXXXXXX");
        //console.log("campo: ", campo);
        //console.log("valor: ", valor);

        let urlServicioRestfulReal= campo.url ?  campo.url : urlServicioRestful;
        return (
            <FormGroup style={{width: '100%'}} key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <ComboBoxClase
                    id={campo.campo}
                    key={index}
                    urlServicioRestful={urlServicioRestful}
                    url={campo.url}
                    clase={campo.clase}
                    campoClave= {campoClave}
                    campoMostrar= {campoMostrar}
                    campoIdMostrar={campoIdMostrar}
                    icon={campo.icon}
                    onValueChanged={(elemento) => {
                        if (elemento)
                            this.changeCampo(campo, elemento[campoClave])
                        else
                            this.changeCampo(campo, null);
                        }
                    }
                    condiciones={campo.condiciones}
                    ordenInicial={campo.ordenInicial}
                    valorInicial={campo.valorInicial} //<- Nuevo
                    mostrarEliminar={true} //<-- Nuevo
                    pausaLoad={campo.pausaLoad}
                    labelInline={labelInLine}
                />

            </FormGroup>
        )
    }

    getRenderComboOpciones= (campo, valor, index) => {
        //console.log("!!!getRenderComboOpciones");
        //console.log("valor: ", valor);
        return (
            <FormGroup style={{width: '100%'}} key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <SelectorOpciones index={index} id={campo.campo}
                                  opciones= {campo.valores}
                                  valor={valor} icon={campo.icon}
                    //titulo={campo.titulo} //Quitado el 11/09/23 Para que se pinte el titulo del group
                                  campoClave={campo.campoClave} campoTexto={campo.campoTexto}
                                  onValueChanged={(valor) => this.changeCampo(campo, valor)}
                />
            </FormGroup>
        )
    }

    getRenderRadio= (campo, valor, index) => {
        return (
            <RadioGroup
                label={campo.titulo}
                onChange={(event) => this.changeCampo(campo, event.target.value)}
                selectedValue={valor}
            >
                {
                    campo.valores.map ( (valor, index) => {
                        return <Radio key={index} label={valor.texto} value={valor.valor} />
                    })
                }
            </RadioGroup>
        )
    }

    getRenderDateTime= (campo, valor, conHora, index) => {
        //let timestampValor= valor ? valor : getTimestampFromNow();
        let timestampValor= valor;
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <DateTimeInput conHora={conHora} valor={timestampValor} obligatorio={campo.obligatorio} onChange={ (datetime) => this.changeCampo(campo, datetime)}/>
            </FormGroup>
        );
    }

    getRenderDateTimeActivable= (campo, valor, conHora, index) => {
        return (
            <DateTimeActivable fecha={valor ? valor : 0} index={index} titulo= {campo.titulo}
                               campo={campo.campo} obligatorio={campo.obligatorio} conHora={campo.conHora}
                               onChange={ (datetime) => this.changeCampo(campo, datetime) } />

        );
    }

    getRenderDateTimeCadena= (campo, valor, conHora, index) => {
        const {tabOrderManager, componentsManager, onBlur} = this.props;
        let valorReal= valor ? valor : 0;
        return (
            <FechaCadenaInput tsValor={valorReal} index={index} titulo= {campo.titulo} icon={campo.icon}
                              id={campo.campo} obligatorio={campo.obligatorio} conHora={conHora}
                              onChange={ (datetime) => this.changeCampo(campo, datetime)}
                              tabOrderManager= {tabOrderManager}
                              componentsManager={componentsManager}
                              completarSegundosAleatorios={true}
                              completarHoraActual={true}
                              iniciarConFechaActual={true}
                              ref={componentsManager.getRef(campo.campo)}
                              readOnly={campo.readOnly ? campo.readOnly : false }
            />

        );
    }

    getRenderSelectorLista= (campo, valor, valorTextoInicial, index) => {
        const {urlServicioRestful, tabOrderManager} = this.props;
        const campoValor= "codigo";
        const campoMostrar= "nombre";
        let elementoSeleccionado= {codigo: valor, nombre: valorTextoInicial}

        /*
        console.log(" +++ getRenderSelectorLista");
        console.log(" campo: ", campo);
        console.log(" valor: ", valor);
        console.log(" valorTextoInicial: ", valorTextoInicial);
        */

        return (
            <SelectorListaClase key={index}
                                urlServicioRestful={urlServicioRestful}
                                clase={campo.tipo}
                                titulo={campo.titulo}
                                campoValor= {campoValor}
                                campoMostrar= {campoMostrar}
                                valor={valor ? valor : 0}
                                valorTextoInicial={valorTextoInicial}
                                elementoSeleccionadoInicial={elementoSeleccionado}
                                icon={campo.icon}
                                onElementoChanged={(elemento) => {
                                    if (elemento)
                                        this.changeCampo(campo, elemento[campoValor])
                                    else
                                        this.changeCampo(campo, null);
                                    }
                                }
                                condiciones={campo.condiciones}
                                ordenInicial={campo.ordenInicial}
                                tabOrderManager={tabOrderManager}
                                campoNombre={campo.campo}
                                usarCache={campo.cache}
            />
        );
    }

    getRenderSelectorListaObjeto= (campo, valor, valorInicial, index) => {
        const {urlServicioRestful, tabOrderManager} = this.props;
        const campoValor= campo.campoValor? campo.campoValor: "codigo";
        const campoMostrar= campo.campoMostrar ? campo.campoMostrar : "nombre";
        const campoIdMostrar= campo.mostrarCampoId ? "codigoid" : null;
        const campoIdTitulo= campo.campoIdTitulo;
        const mostrarTitulo=  campo.mostrarTitulo == null || Boolean(campo.mostrarTitulo);

        const urlServicioRestfulReal= campo.urlServicio ? campo.urlServicio : urlServicioRestful;



        console.log("^^^ getRenderSelectorListaObjeto ^^^", campo.titulo);
        //console.log("campo.onAbrirFormularioElemento: ", campo.onAbrirFormularioElemento);
        /*
        console.log("campo:");
        console.log(campo);
        console.log("valor");
        console.log(valor);
        console.log("valorInicial");
        console.log(valorInicial);
        */

        return (
            <SelectorListaClaseObjeto key={index}
                                urlServicioRestful={urlServicioRestfulReal}
                                clase={campo.tipo}
                                titulo={ mostrarTitulo ? campo.titulo : ""}
                                campoValor= {campoValor}
                                campoMostrar= {campoMostrar}
                                campoIdMostrar= {campoIdMostrar}
                                campoIdTitulo={campoIdTitulo}
                                valor={valor ? valor : {}}
                                valorInicial={valorInicial}
                                icon={campo.icon}
                                onElementoChanged={(elemento) => {
                                    if (elemento) {
                                        this.changeCampo(campo, elemento)
                                    }
                                    else
                                        this.changeCampo(campo, null);
                                    }
                                }
                                condiciones={campo.condiciones}
                                tabOrderManager={tabOrderManager}
                                campoNombre={campo.campo}
                                obligatorio={campo.obligatorio}
                                columnasAdicionales={campo.columnasAdicionales}
                                usarCache={campo.cache}
                                mostrarCodigoid={campo.mostrarCodigoid}
                                //tipoGrid="reactdatagrid"
                                onPropiedadesServicio={campo.onPropiedadesServicio}

                                onAccion={campo.onAccion}
                                accionIcon={campo.accionIcon}
                                onAbrirFormularioElemento={campo.onAbrirFormularioElemento}

                                readonly={campo.readonly}
            />
        );
    }


    getRenderImagenURL= (campo, valor, index) => {
        let imagenURL= servidorImagenes + "trabajador1.jpg"; //+ valor;
        return (
            <img src={imagenURL} alt="new" />

        );
    }

    getRenderImagenURLUploader= (campo, valor, index) => {
        //console.log("ComponenteEntrada - getRenderOmagenURLUploader");
        //console.log("valor: ", valor);

        let servidorDownloadUrl= campo.servidorDownloadUrl ? campo.servidorDownloadUrl : servidorImagenes;
        let imagenURL= valor ? servidorDownloadUrl + valor : servidorDownloadUrl + "nodefinido.jpg"; //+ valor;
        let servicioUploadURL= campo.servicioUploadUrl;
        //let servicioUploadURL=    servidor + servicioFicheros + "upload/personal" ;

        //console.log(imagenURL);

        return (
            <ImagenUploader imagenUrl={imagenURL} servicioUploadUrl={servicioUploadURL}
                            titulo={campo.titulo} anchoImagen={campo.anchoImagen}
                            fileNameNoDefinido={"nodefinido.jpg"}
                            onChange={ (imagen) => this.changeCampo(campo, imagen)}/>
        );
    }

    getRenderSelectorPeriodo= (campo, valor, index) => {
        return (
            <SelectorPeriodo titulo={campo.titulo} tipoValor={Number(campo.tipoValor)} onChange={ (periodo) => this.changeCampo(campo, periodo) }/>
        );
    }

    getRenderColorPicker= (campo, valor, index) => {
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo}>
                <ColorPicker
                    color={ valor }
                    onChange={ (color) => this.changeCampo(campo, color)}
                />
            </FormGroup>
        );
    }

    getRenderTimePicker= (campo, valor, index) => {
        //console.log("render TimePicker:");
        //console.log("valor: ", valor);
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo}>
                <TimeInput
                    hora={valor}
                    onChange={ (hora) => this.changeCampo(campo, hora)}
                />
            </FormGroup>
        );
    }

    getRenderMemo= (campo, valor, index) => {
        let style = {
            height: campo.height ? campo.height : '100px',
        }
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <TextArea
                    style={style}
                    fill={true}
                    growVertically={true}
                    large={true}
                    onChange={(event) => this.changeCampo(campo, event.target.value)}
                    value={valor}
                />
            </FormGroup>
        );
    }

    getRenderLabel= (campo, valor, index) => {
        let texto= valor ? campo.sufijo ? valor + " " + campo.sufijo : valor  : "";
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo}>
                <div>{texto}</div>
            </FormGroup>
        );
    }

    getRenderListaChecks= (campo, valor, index) => {
        //let marcadosIniciales= valor ? valor.split(",").map(Number) : [];
        let marcadosIniciales= valor ? StringDeNumeroToArrayDeNumeros(valor) : [];
        return (
            <ListaChecks titulo= {campo.titulo}
                             items={campo.valores} campoTexto="nombre" campoId="codigo"
                             marcadosIniciales={marcadosIniciales}
                             onMarcadosChanged={(newMarcados) => this.changeCampo(campo, ArrayDeNumerosToStringDeNumeros(newMarcados))}
                             estilo={{marginLeft:'10px', width: '80%', border: "1px solid black"}}
                             mostrarBotones={campo.mostrarBotones}
            />
        );
    }

    /*
    getRenderIconoAccion= (campo, valor, index) => {
        return (
            <Icon icon={campo.icon} onClick={ () => this.onClick(campo)} />
        )
    }

    getRenderBotonAccion= (campo, valor, index) => {
        return (
            <Button icon={campo.icon} onClick={ () => this.onClick(campo)}>
                {campo.titulo}
            </Button>
        )
    }
    */

    getRenderComboImpresoras= (campo, valor, index) => {
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <ComboBoxImpresoras
                    id= {campo.campo}
                    onValueChanged={(objeto) => this.changeCampo(campo, objeto.nombre)}
                    valor={valor}
                />
            </FormGroup>
        )
    }

    getRenderSelectorDocumentos= (campo, valor, valorTextoInicial, index) => {
        const {urlServicioRestful, tabOrderManager} = this.props;

        return (
            <SelectorDocumentos key={index}
                                urlServicioDocumentos={servidor + servicioDocumental}
                                titulo={campo.titulo}
                                documento={valorTextoInicial}
                                onDocumentoAceptado={(documento) => {
                                    //console.log("DocumentoAceptado: ", documento);
                                    if (documento)
                                        this.changeCampo(campo, documento)
                                    else
                                        this.changeCampo(campo, null);
                                }
                                }
                                tabOrderManager={tabOrderManager}
            />
        );
    }

    getRenderInputAccion= (campo, valor, index) => {
        const {tabOrderManager} = this.props;
        let readonlyReal= campo.readonly && Boolean(campo.readonly);
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo} labelInfo={ campo.obligatorio ? "*" : ""}>
                <div className="selectorlista">
                    <div className="selectorlista_input">
                        <InputGroup
                            id= {campo.campo}
                            leftIcon= { campo.icon ? campo.icon : this.getIcon(campo)}
                            placeholder= {campo.titulo}
                            value={valor ? valor : ""}
                            onChange={ (event) => this.changeCampo(campo,
                                campo.noMayus ? event.target.value : event.target.value.toUpperCase())  }
                            inputRef={ campo.campo && tabOrderManager ? tabOrderManager.getRef(campo.campo) : null }
                            onKeyPress={(target) => {this.keyPress(target, campo.campo)}}
                            //onBlur={onBlur ? () => onBlur(campo) : null}
                            onBlur={() => this.blur(campo)}
                            readOnly={campo.readOnly ? campo.readOnly : false }
                        />
                    </div>
                    {!readonlyReal &&
                    <Button icon={campo.icon} className="selectorlista_boton" onClick={() => campo.onAccion(valor)}/>
                    }
                    {(!readonlyReal && campo.icon2) &&
                    <Button icon={campo.icon2} className="selectorlista_boton" onClick={() => campo.onAccion2(valor)}/>
                    }
                </div>
            </FormGroup>
        );
    }


    /* Para usar este render, el campo tiene que tener:
        render --> retorna el render del componente

    getRenderComponente= (campo, valor, index) => {
        if (campo.render)
            return campo.render();
    }
    */

    getRenderHTMLMemo= (campo, valor, index) => {
        //console.log("getRenderHTMLMemo: ", valor);
        return (
            <FormGroup key={index} label= {campo.titulo} labelFor={campo.campo}>
                <HTMLEditorQuill id={campo.campo}
                                 texto={valor}
                                 height={campo.height}
                                 onChange={(valor) => this.changeCampo(campo, valor)}
                />
            </FormGroup>
        )
    }

    getRenderFirmaMail= (campo, valor, index) => {
        console.log("GETRENDERFIRMAMAIL");
        console.log("valor:", valor);
        return (
            <FirmaMail titulo={campo.titulo} firma={valor} mostrarRender={true} onChange={(valor) => this.changeCampo(campo, valor)}/>
        )
    }

    getRenderFile= (campo, valor, index) => {
        return(
            <div>valor</div>
        )

    }

    changeCampo = (campo, valor) => {
        /*
        console.log("COMPONENTEENTRADA: changeCampo");
        console.log("campo: ", campo.campo);
        console.log("valor: ", valor);
        */
        if (!campo.readOnly) {
            const {onChange} = this.props;
            onChange && onChange(campo, valor);
        }
    }


    render() {
        const {campo} =  this.state;
        const {valor, valorTextoInicial, index} = this.props;
        return (
            <>
            {
                this.getRenderFromCampo(campo, valor, valorTextoInicial, index)
            }
            </>

        );
        }
    }

    ComponenteEntrada.propTypes = {
        urlServicioRestful: PropTypes.string,
        campo: PropTypes.object.isRequired,
        valor: PropTypes.any,
        //valorTextoInicial: PropTypes.string,
        valorTextoInicial: PropTypes.any,
        onChange: PropTypes.func,
        index: PropTypes.number,
        onUploadImage: PropTypes.func,
        tabOrderManager: PropTypes.object,
        componentsManager: PropTypes.object,
        labelInLine: PropTypes.bool,
    }



export default ComponenteEntrada

